<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label"><span class="mr-2">Request Form Info </span></div>
    </div>

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="row mb-4">
        <div class="col-4">
          <div class="header-col">
            <div>FTIE ID</div>
            <div>{{ _.get(request_form, 'ftie_id', '') }} </div>
          </div>
          <div class="header-col">
            <div>Vertical</div>
            <div>{{ _.get(request_form, 'vertical', '') }} </div>
          </div>
          <div class="header-col">
            <div>Price</div>
            <div>{{ _.get(request_form, 'price', '') }} </div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Request Form ID</div>
            <div>{{ _.get(request_form, 'uni_id', '') }}</div>
          </div>
          <div class="header-col">
            <div>Create Date</div>
            <div>{{ _.get(request_form, 'create_date', '') | dateTimeFormat }} </div>
          </div>
          <div class="header-col">
            <div>Status</div>
            <div>{{ _.get(request_form, 'status', '') }} </div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Project</div>
            <div>{{ _.get(request_form, 'project', '') }}</div>
          </div>
          <div class="header-col">
            <div>Qty</div>
            <div>{{ _.get(request_form, 'qty', '') }}</div>
          </div>
          <div class="header-col">
            <div>Create by</div>
            <div>{{ _.get(request_form, 'create_by', '') }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Proposal Sharepoint Url</div>
            <div> <a v-if="_.get(request_form, 'customization_proposal_url', '') !=='' &&_.get(request_form, 'customization_proposal_url', '') !=null" class="link" target="_blank" :href="safeUrl(`${ _.get(request_form, 'customization_proposal_url', '')}`)">{{ _.get(request_form, 'model', '') }};FTIE ID{{ _.get(request_form, 'ftie_id', '') }};Request Form ID{{ _.get(request_form, 'uni_id', '') }} </a></div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Complete Date</div>
            <div v-if="_.get(tl_approval, 'last_update_date', '') !=='' &&_.get(tl_approval, 'last_update_date', '') !=null"> {{_.get(tl_approval, 'last_update_date', '') | dateFormat}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--#endregion -- Header ---->
    <!--#region -- Body ---->
    <div class="caption-label d-flex align-items-center">
      <div>RD Check Item</div>
    </div>
    <div v-if="rd_check_item_data !=null" class="table-responsive" style="min-height: 2.5rem;">
      <b-table :fields="fields" :items="rd_check_item_data"
               small
               thead-class="thead-light text-dark"
               style="width: calc(100% - 10px)">

        <template #cell(special_list)="data">
          <gtc-textarea :read-only="data.item.owner!==login_user_name" class="" v-model="data.item.special_list" />
        </template>

        <template #cell(schedule_m_d)="data">
          <gtc-textarea :read-only="data.item.owner!==login_user_name" class="" v-model="data.item.schedule_m_d" />
        </template>

        <template #cell(man_power)="data">
          <gtc-textarea :read-only="data.item.owner!==login_user_name" class="" v-model="data.item.man_power" />
        </template>

        <template #cell(relation_dept)="data">
          <gtc-textarea :read-only="data.item.owner!==login_user_name" class="" v-model="data.item.relation_dept" />
        </template>

        <template #cell(rd_check_item_details)="data">
          <b-form-checkbox v-for="detail, index in data.item.rd_check_item_details" :key="index" v-model="detail.item_check_yn"
                           :disabled="checkBelongOwner(data.item.owner)"
                           value="Y" unchecked-value="N">{{detail.item_detail}}</b-form-checkbox>
        </template>
        <template #cell(action)="data">
          <b-button v-if="data.item.owner===login_user_name" variant="primary" @click="updateCheckItemDetail(data.item)">Update</b-button>
        </template>
        <template #cell(agree)="data">
          <b-form-radio-group v-model="data.item.agree">
            <b-form-radio value="Y">Yes</b-form-radio>
            <b-form-radio value="N">No</b-form-radio>
          </b-form-radio-group>
        </template>

      </b-table>
    </div>
        <!-- Custom Level 選擇結果區塊，移到 RD Check Item 和 RD Leader Comment 之間 -->
    <div class="custom-level-result-block mb-2">
      <div class="d-flex align-items-center mb-1 flex-wrap">
        <div class="caption-label mb-0 mr-2">Complexity Level</div>
        <span class="ml-2 text-info font-weight-bold" style="font-size: 1.1rem;">{{ displayCustomWeightOld }}</span>
        <div class="ml-3 d-print-none" v-if="login_user_name==='albert.chen' && !(_.get(tl_approval, 'last_update_date', '') !=='' &&_.get(tl_approval, 'last_update_date', '') !=null)">
          <b-button size="sm" variant="outline-primary" @click="showCustomLevelModal">Edit Custom Level</b-button>
        </div>
      </div>
      <div class="mb-1">
        <span v-for="(item, idx) in customlevelModalData.oldCustomLevelList" :key="item.uni_id" class="badge badge-secondary mr-1 mb-1">
          {{ item.description }}
        </span>
      </div>
    </div>
    <div class="caption-label d-flex flex-nowrap" v-if="login_user_name==='albert.chen'">
      RD Leader Comment
      <div class="ml-3 mb-1 d-print-none">
        <b-form-select class="min-w-2" :options="tl_comments_option" label="TL Comments:" @change="handleInputChange"></b-form-select>
      </div>
    </div>

    <div class="col-6">
      <gtc-textarea class="mb-2" v-model="fesc_tl_comment" v-if="login_user_name==='albert.chen'" />
      <b-button variant="primary" @click="updateRequestForm(false)" v-if="login_user_name==='albert.chen'">Comment Submit</b-button>
      <b-button variant="primary" @click="updateRequestForm(true)" v-if="login_user_name==='albert.chen' || isProposalLeader">Proposal Complete</b-button>
    </div>


    <!--#region Reference Files-->
    <!--<div class="row" v-if="login_user_name==='albert.chen' || login_user_name==='corin.chiu'">
    <div class="col-6">
      <div class="caption-label d-flex">
        <div>RD Leader Summarize Comment</div>
      </div>
      <div>
        <gtc-textarea :read-only="false" v-model="rd_leader_comment" />
        <b-button variant="primary" @click="updateRdLeaderComment">Save</b-button>
      </div>
    </div>

  </div>-->
    <!--<div class="row" v-if="login_user_name==='albert.chen' || login_user_name==='corin.chiu' ">
  <div class="col-6">
    <div class="caption-label d-flex">
      <div>RD Leader Summarize</div>
      <div class="ml-3 mt-2 d-print-none">
        <label class="btn btn-primary btn-sm">
          <span>Upload</span>
          <input type="file" class="d-none" v-on:change="uploadfile($event)" />
        </label>
      </div>
    </div>

    <div>
      <b-table  small thead-class="thead-light text-dark" style="table-layout: fixed;" :items="ref_proposal_files" :fields="referenceFilesSetting">

        <template #cell(file_name)="data">
          <a class="link" @click="downloadAttachment(data.item.file_name,  data.item.old_file_name )">{{ data.item.old_file_name }}</a>
        </template>
      </b-table>
    </div>-->
    <!--#endregion-->
    <!--#endregion -- Body ---->

    <!--#region -- Edit custom level Modal ---->
    <b-modal centered size="lg"
             :ok-title="`Save`"
             @ok="saveCustomLevel"
             ref="customLevelModal"
             title="Edit Complexity Level"
             button-size="sm">
      <div v-if="customCategoryList" style="padding-top: 0px;">
        <b-form-group label="Complexity Item"
                      class="header-col">
          <div style="padding-bottom: 10px;">
            <strong>{{displayCustomWeight}}</strong>
          </div>
          <b-form-checkbox v-for="option in customCategoryList"
                           v-model="selectedCategory"
                           :key="option.description"
                           :value="option.uni_id"
                           name="custom-level-options"
                           stack>
            {{ option.description }}
          </b-form-checkbox>
        </b-form-group>
      </div>
    </b-modal>
    <!-- #enregion Modal -->
    <!--</div>
  </div>-->
  </div>



</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'rd-check-item',
    data() {
      return {
        function_name: 'RD Check Item ',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        login_user_name: null,
        userSites: null,
        userRoles: null,
        userFunctions: null,
        fields: null,
        referenceFilesSetting: [
          { key: 'file_name', label: 'File Name', thClass: 'align-middle ', sortable: false },
          { key: 'create_date', label: 'Create Date', thClass: 'align-middle ', sortable: false }
        ],
        rd_check_item_data: null,
        request_form: null,
        rd_leader_comment: null,
        ref_proposal_files: [],
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        tl_comments_option: [
          'Goto Kickoff directly.',
          'Need Feasibility check meeting with PM',
          'Create PN/BOM directly.',
          'Feasibility check directly.',
          'Other Comments'
        ],
        proposal_complete_date: null,
        fesc_tl_comment: null,
        tl_approval: null,
        selectedCategory: [],
        // displayCustomWeight: '',
        // displayCustomFinalResult: '',
        initialCustomWeightDisplay: '',
        initialCustomWeightLoaded: false,
        customCategoryList: [],
        customlevelModalData: {
          oldCustomLevelList: [],
        },
      }
    },
    created() {
      let self = this;
      self.getRdCheckItem();
      self.initCustomLevelData();

    },
    computed: {
      isProposalLeader() {
        let self = this;
        if (!self.rd_check_item_data){
          return false;
        }
        const found = self.rd_check_item_data.find(x => x.sub_function_name === 'Proposal Leader' && x.owner === self.login_user_name);
        return !!found;
      },
      displayCustomFinalResult() {
        const oldList = this.customlevelModalData.oldCustomLevelList || [];
        return oldList.length > 0 ? oldList.map(x => x.description).join(', ') : '';
      },
      displayCustomWeight() {
        // 計算目前選取的 custom level 數量與總權重
        if (!this.selectedCategory || this.selectedCategory.length === 0) {
          return 'Not chosen yet';
        }
        let totalWeight = 0;
        for (let i = 0; i < this.selectedCategory.length; i++) {
          const selectedId = this.selectedCategory[i];
          const option = this.customCategoryList.find(x => x.uni_id === selectedId);
          let weight = option ? option.complexity_level : 0;
          totalWeight += weight;
        }
        return `${this.selectedCategory.length} Selected, Weight ${totalWeight}`;
      },
      displayCustomWeightOld() {
        // 計算DB儲存的 custom level 數量與總權重
        const oldList = this.customlevelModalData.oldCustomLevelList || [];
        if (!oldList.length) return '';
        let totalWeight = 0;
        for (let i = 0; i < oldList.length; i++) {
          const item = oldList[i];
          const option = this.customCategoryList.find(x => x.uni_id === item.uni_id);
          let weight = option ? option.complexity_level : 0;
          totalWeight += weight;
        }
        let level = '';
        if (totalWeight === 1) {
          level = 'Low';
        } else if (totalWeight === 2) {
          level = 'Midium';
        } else if (totalWeight >= 3) {
          level = 'Heavy';
        }
        return `Level: ${level}`;
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.checkRdLeader();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
    },
    methods: {
      checkRdLeader() {
        let self = this;
        if (self.login_user_name === 'albert.chen') {
          self.fields = [
            { key: 'sub_function_name', label: 'Sub Function Name', thClass: 'align-middle', sortable: false },
            { key: 'owner', label: 'Owner', thClass: 'align-middle', sortable: false },
            { key: 'rd_check_item_details', label: 'Check Item', thClass: 'align-middle', sortable: false },
            { key: 'special_list', label: 'Special List', thClass: 'align-middle', sortable: false },
            { key: 'schedule_m_d', label: 'Schedule', thClass: 'align-middle', sortable: false },
            { key: 'man_power', label: 'Man Power', thClass: 'align-middle', sortable: false },
            { key: 'relation_dept', label: 'Relation Dept', thClass: 'align-middle', sortable: false },
            { key: 'agree', label: 'RD Leader Agree', thClass: 'align-middle', sortable: false }
          ]
        } else {
          self.fields = [
            { key: 'sub_function_name', label: 'Sub Function Name', thClass: 'align-middle', sortable: false },
            { key: 'owner', label: 'Owner', thClass: 'align-middle', sortable: false },
            { key: 'rd_check_item_details', label: 'Check Item', thClass: 'align-middle', sortable: false },
            { key: 'special_list', label: 'Special List', thClass: 'align-middle', sortable: false },
            { key: 'schedule_m_d', label: 'Schedule', thClass: 'align-middle', sortable: false },
            { key: 'man_power', label: 'Man Power', thClass: 'align-middle', sortable: false },
            { key: 'relation_dept', label: 'Relation Dept', thClass: 'align-middle', sortable: false },
            { key: 'action', label: 'Action', thClass: 'align-middle', sortable: false },
          ]
        }
      },
      checkBelongOwner(owner) {
        let self = this;
        let check_disable_result = true;
        /**

if (self.login_user_name === owner) {
          check_disable_result = false;
        }
*/

        if (
          (self.login_user_name === owner) || self.$options.filters['adminAccessFtie'](self.login_user_name, null, null) === true
          || (self.userSites && self.userSites.includes('Getac') && self.userFunctions && _.indexOf(self.userFunctions, 'Tech Leader') > -1)
        ) {
          check_disable_result = false;
        } else {
          check_disable_result = true;
        }

        return check_disable_result;
      },
      getCustomCategoryList() {
        let self = this;

        let requestData = {};
        let result_obj = null;
        eventHub.$emit('loading', true);
        return this.$axios
          .post(self.$root.baseUrl + '/nre/custom-category/list/', requestData)
          .then(res => {
            let result = res.data;
            if (res.status === 200) {
              result.custom_category_level_info_list = JSON.parse(result.custom_category_level_info_list);
              self.customCategoryList = result.custom_category_level_info_list;
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      async showCustomLevelModal() {
        let self = this;
        if (_.size(self.customCategoryList) === 0) {
          await self.getCustomCategoryList();
        }
        self.$refs['customLevelModal'].show();
      },
      getBackendOldCustomLevels() {
        let self = this;
        const requestData = {
          ftie_id: _.get(self.$route, 'params.ftie_id', null),
          request_form_id: _.get(self.$route, 'params.request_form_id', null),
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios
          .post(self.$root.baseUrl + '/nre/custom-complexity/list/', requestData, { params })
          .then((response) => {
            var res = response.data;
            const result = _.get(res, 'custom_complexity_level_list', []);
            console.log(result);
            const oldList = _.map(result, (desc) => ({
              uni_id: desc['COMPLEXITY_ITEM_ID'],
              description: desc['DESCRIPTION']
            }));
            _.set(self.customlevelModalData, 'oldCustomLevelList', oldList);
            self.selectedCategory = _.map(oldList, 'uni_id');
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      //applyOldCustomLevelList(oldCustomLevels) {
      //  let self = this;
      //  _.set(self.customlevelModalData, 'oldCustomLevelList', JSON.parse(JSON.stringify(oldCustomLevels || [])));
      //  self.selectedCategory = _.map(_.get(self.customlevelModalData, 'oldCustomLevelList', []), 'description');
      //  self.displayCustomFinalResult = _.size(self.selectedCategory) > 0 ? _.join(self.selectedCategory, ', ') : '';
      //},
      buildCustomLevelDelta() {
        let self = this;
        // 以 uni_id 為主比較
        const oldList = _.get(self.customlevelModalData, 'oldCustomLevelList', []) || [];
        const oldIds = _.chain(oldList)
          .map(x => x.uni_id)
          .filter(x => x != null && x !== '')
          .uniq()
          .value();
        const newIds = _.chain(self.selectedCategory)
          .filter(x => x != null && x !== '')
          .uniq()
          .value();

        // 只回傳 customCategoryList 物件，找不到則只回傳 uni_id
        const getFullObject = (uni_id) => {
          const found = self.customCategoryList.find(x => x.uni_id === uni_id);
          return found || { uni_id };
        };

        return {
          add_list: newIds.filter(id => !oldIds.includes(id)).map(getFullObject),
          delete_list: oldIds.filter(id => !newIds.includes(id)).map(getFullObject),
          current_list: newIds.map(getFullObject),
        };
      },
      async initCustomLevelData() {
        let self = this;
        await self.getCustomCategoryList();
        await self.getBackendOldCustomLevels();
      },

      saveCustomLevel() {
        let self = this;
        const delta = self.buildCustomLevelDelta();
        const requestData = {
          create_by: self.login_user_name,
          username: self.login_user_name,
          ftie_id: _.get(self.$route, 'params.ftie_id', null),
          request_form_id: _.get(self.$route, 'params.request_form_id', null),
          add_complexity_levels: delta.add_list,
          delete_complexity_levels: delta.delete_list,
          complexity_levels: delta.current_list,
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        eventHub.$emit('loading', true);
        self.$axios
          .post(self.$root.baseUrl + '/nre/custom-complexity/update/', requestData, { params })
          .then((res) => {
            const result = _.get(res, 'data', {});
            if (res.status !== 200) {
              if (result.description == 'login') {
                self.$session.destroy();
                self.$store.commit('clearToken');
                var url = self.$root.baseUrl + '/auth/logout/';
                self.$axios.get(url)
                  .then(() => {
                    self.$router.push('/');
                  });
                window.location = self.frontEndUrlToUse + 'azure-login';
                return;
              }
              self.$message.exception('Internal Server Error!');
              return;
            }

            self.selectedCategory = _.chain(self.selectedCategory).filter((x) => x !== null && x !== '').uniq().value();
            _.set(self.customlevelModalData, 'oldCustomLevelList', _.map(self.selectedCategory, (desc) => ({ description: desc })));
            // displayCustomFinalResult 改為 computed，不需在此設定

            self.$message.info('Complexity Level 儲存成功');
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.$nextTick(() => {
              self.initCustomLevelData();
            });
          });
      },
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');



        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);

        this.login_user_name = user_name;
        this.userSites = user_site;
        this.userRoles = user_roles;
        this.userFunctions = user_functions;

      },
      getRdCheckItem() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/rd-check-item/';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          ftie_id: encodeURI(self.$route.params.ftie_id),
          request_form_id: encodeURI(self.$route.params.request_form_id)
        };

        let rd_check_item_data = null;
        let request_form = null;
        let ref_proposal_files = null;
        eventHub.$emit('loading', true);
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              rd_check_item_data = JSON.parse(res['rd_check_item_data']);
              request_form = JSON.parse(res['request_form']);
              ref_proposal_files = JSON.parse(res['ref_proposal_files']);
              self.tl_approval = _.find(JSON.parse(res['request_form_approvals']), { approval_function: 'FESC TL' });
              console.log(rd_check_item_data);
              self.rd_check_item_data = rd_check_item_data;
              self.request_form = request_form;
              self.ref_proposal_files = ref_proposal_files;
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      updateCheckItemDetail(rd_check_item) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/rd-check-item/';
        let request_data = {
          rd_check_item: rd_check_item
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                //window.location = this.$root.frontEndUrl + '/ftie/rd-check-item' + '/' + encodeURIComponent(self.$route.params.ftie_id) + '/' + encodeURIComponent(self.$route.params.request_form_id);
                window.location = this.frontEndUrlToUse + 'ftie/rd-check-item' + '/' + encodeURIComponent(self.$route.params.ftie_id) + '/' + encodeURIComponent(self.$route.params.request_form_id);
              }
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      uploadfile(event) {
        let self = this;
        let maxLength = Number(self.$root.maxRequestLength);
        if (event) event.preventDefault();
        if (event.target.files.length === 0) return;
        if (_.first(event.target.files).size > maxLength) {
          self.$message.warning('Maximum limit for exceeding single file uploads (10MB)');
          return;
        }

        //#region -- formData --
        let formData = new FormData();
        formData.append('file', _.first(event.target.files));
        formData.append('ftie_id', self.$route.params.ftie_id);
        formData.append('request_form_id', self.$route.params.request_form_id);
        formData.append('user_name', self.$store.state.username);
        formData.append('user_role', 'RD leader');
        //#endregion
        //#region -- Data Upload --

        eventHub.$emit('loading', true);
        self.$axios
          .post(
            self.$root.baseUrl + '/ftie/upload-proposal-file/',
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          .then(res => {
            window.location = this.$root.frontEndUrl + '/ftie/rd-check-item' + '/' + encodeURIComponent(self.$route.params.ftie_id) + '/' + encodeURIComponent(self.$route.params.request_form_id);
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      updateRdLeaderComment() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/approve-summary-comment/';
        let request_data = {
          rd_leader_comment: self.rd_leader_comment,
          ftie_id: self.$route.params.ftie_id,
          request_form_id: self.$route.params.request_form_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                window.location = this.$root.frontEndUrl + '/ftie/rd-check-item' + '/' + encodeURIComponent(self.$route.params.ftie_id) + '/' + encodeURIComponent(self.$route.params.request_form_id);
              }
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      downloadAttachment(file_name, origin_file_name) {
        let self = this;
        let url = self.$root.baseUrl + '/upload_file/' + file_name;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          origin_file_name: origin_file_name
        };
        eventHub.$emit('loading', true);
        self.$axios.get(url, { params, responseType: 'arraybuffer' })
          .then((response) => {
            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              console.log("file_name =" + origin_file_name);
              link.setAttribute('download', origin_file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (response.status === 401) {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      handleInputChange(event) {
        let self = this;
        self.fesc_tl_comment = event;
      },
      updateRequestForm(complete_flag) {
        let self = this;
        // 檢查 Proposal Complete 時 oldCustomLevelList 不能為空
        if (complete_flag && (!self.customlevelModalData.oldCustomLevelList || self.customlevelModalData.oldCustomLevelList.length === 0)) {
          self.$message.warning('請先設定 Complexity Level 才能完成Proposal');
          return;
        }
        let url = self.$root.baseUrl + '/ftie/update-request-form-approval/';
        let temp_date = null;
        let temp_comment = null;
        if (complete_flag) {
          temp_date = moment().format('YYYY-MM-DD');
        } else {
          temp_comment = self.fesc_tl_comment
        }
        let request_data = {
          request_form_id: self.request_form.uni_id,
          proposal_complete_date: temp_date,
          update_comments: temp_comment,
          ftie_id: self.request_form.ftie_id,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                self.$message.info('Save success!');
              } else {
                self.$message.exception('Save fail!');
              }

            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.fesc_tl_comment = null
            self.getRdCheckItem();
          })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_RdCheckItem.vue